import { useState, useEffect } from 'react';
import axios from 'axios';

const baseURL = 'http://localhost:5001';

const useTaskManager = () => {
  const [history, setHistory] = useState([]);
  const [taskStatuses, setTaskStatuses] = useState({});

  useEffect(() => {
    const stored = localStorage.getItem('task_history');
    if (stored) {
      setHistory(JSON.parse(stored));
    }
  }, []);

  useEffect(() => {
    localStorage.setItem('task_history', JSON.stringify(history));
  }, [history]);

  useEffect(() => {
    const interval = setInterval(() => {
      history.forEach(task => {
        const current = taskStatuses?.[task.task_id]?.status;
        if (!current || current === 'running') {
          pollTaskStatus(task.task_id);
        }
      });
    }, 3000);
    return () => clearInterval(interval);
  }, [history, taskStatuses]);

  const pollTaskStatus = async (taskId) => {
    try {
      const res = await axios.get(`${baseURL}/task_status?task_id=${taskId}`);
      const { status, files, file } = res.data;
      setTaskStatuses(prev => ({
        ...prev,
        [taskId]: { status, files, file }
      }));
    } catch (err) {
      console.warn(`❌ 获取任务状态失败 ${taskId}`, err.message);
    }
  };

  const checkStatus = (taskId) => {
    pollTaskStatus(taskId);
  };

  const handleTask = async (type, formData, endpoint) => {
    try {
      const res = await axios.post(`${baseURL}/${endpoint}`, formData);
      const { task_id, filename } = res.data;

      const newTask = {
        task_id,
        type,
        method: formData.get('method') || formData.get('dockingMode') || 'default',
        file: filename || null,
        time: new Date().toLocaleString(),
        status: 'running'
      };

      setHistory(prev => [...prev, newTask]);
      return task_id;
    } catch (err) {
      console.error('❌ 任务提交失败', err.message);
    }
  };

  const clearHistory = () => {
    setHistory([]);
    setTaskStatuses({});
    localStorage.removeItem('task_history');
  };

  return {
    history,
    setHistory,
    taskStatuses,
    setTaskStatuses,
    handleTask,
    checkStatus,
    clearHistory
  };
};

export default useTaskManager;
